import { api, sendRequest } from "services/restUtil";
import { ResolvedPreferences, UpdatePreferencesArgs } from "./tools";

export function createTallyConversation(
  offer: RTCSessionDescriptionInit
): Promise<Response> {
  return sendRequest("POST", "/tally/conversations", {
    body: offer.sdp,
    headers: {
      "Content-Type": "application/sdp",
      Accept: "application/sdp",
    },
  });
}

export async function updateTallyPreferences(args: UpdatePreferencesArgs) {
  return api.post<UpdatePreferencesArgs, ResolvedPreferences>("/tally/preferences", args);
}
